module.exports = __webpack_public_path__ + "img/airport_shuttle.562c53de.svg";